var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.headBlockProducer && _vm.headBlockProducer != 'N/A')?_c('v-chip',{staticClass:"mr-3",staticStyle:{"height":"36px","background-color":"white !important"},attrs:{"color":"black","outlined":"","label":""}},[_vm._v(" Current Producer: "+_vm._s(_vm.headBlockProducer)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }